import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mUSDT.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mUSDT.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  testnetAddress: "0x5d211217D8311E2dEe17aE3F06Ce473922D1a7a4",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
